import { render, staticRenderFns } from "./FolderThumb.vue?vue&type=template&id=11d86879&scoped=true&"
import script from "./FolderThumb.vue?vue&type=script&lang=js&"
export * from "./FolderThumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d86879",
  null
  
)

export default component.exports